export const ErrorMessagesTypes = {
  scheduleDriver: 'Не удалось установить водителя',
  scheduleContractDriver: 'Не хватает данных для договора',
  scheduleCreateContract: 'Не удалось создать договор',
  scheduleBindDriver: 'Не удалось связать машину с водителем',
  scheduleUnbindDriver: 'Не удалось отвязать машину от водителя',
}
